import { useEffect } from "react";
import { Box } from "@mui/material";
import DataTable from "react-data-table-component";
import { FlexGrid, Typography, useThemeProvider, Card, Skeleton } from "@albo-ui/core";
import { useCustomerHistoryHandle } from "./hooks/useCustomerHistoryHandle";
import { paginationComponentOptions } from "../../../util/i18n-es";
import { noDataComponent } from "../../../util/DataObject";
import { customStyles2 } from "../../../util/TableStyles";
import { CustomerHistoryProps } from "./types";
import CustomPagination from "../../elements/CustomPagination";
import ImageSearchIcon from "@mui/icons-material/ImageSearch";
import CustomTab from "../../elements/CustomTab";

export const CustomerHistoryGet = ({ changeAlert, changeLoader, sectionData }: CustomerHistoryProps) => {
    const { theme } = useThemeProvider();

    const {
        data,
        uuid,
        columns,
        loading: loadingTable,
        page,
        rowsPerPage,
        totalRows,
        tabActive,
        tabs,
        saveData,
        changeTab,
        changePage,
        handleChangeRowsPerPage,
    } = useCustomerHistoryHandle(changeAlert);

    useEffect(() => {
        saveData(sectionData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sectionData]);

    useEffect(() => {
        changeLoader(loadingTable);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable]);

    return (
        <Card padding={5} fullWidth fullHeight flexDirection="column" alignItems="stretch" justifyContent="space-between" style={{ borderColor: theme.colors.manatee, margin: 3 }}>
            <FlexGrid container fullWidth justify="space-between" style={{ display: "flex", marginBottom: 25 }}>
                <FlexGrid item>
                    <Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem"}}>
                        <ImageSearchIcon sx={{ marginRight: 1 }} /> Consulta de eventos históricos
                    </Typography>
                    <Box my={1} sx={{fontStyle: "italic", fontWeight: "500 !important"}}>
                        UUID: {uuid}
                    </Box>
                </FlexGrid>
            </FlexGrid>

            <FlexGrid container>
                {loadingTable ? (
                    <Skeleton width="100%" height="100px" />
                ) : (
                    <FlexGrid fullWidth>
                        <CustomTab
                            tabs={tabs}
                            tabActive={tabActive}
                            changeTab={changeTab}
                        />
                        <DataTable
                            columns={columns}
                            data={data}
                            customStyles={customStyles2}
                            noDataComponent={noDataComponent}
                            progressPending={loadingTable}
                            paginationComponentOptions={
                                paginationComponentOptions
                            }
                        />
                        <CustomPagination
                            rows={totalRows}
                            page={page - 1}
                            rowsPerPage={rowsPerPage}
                            handleChangePage={changePage}
                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </FlexGrid>
                )}
            </FlexGrid>
        </Card>
    );
};
